export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/ob-step-2.png?5189a2dd4842bb72e8b01ea4bd86b2ed";